
import '../../css/svformwerror.css'
import { SVMCIInputEp,SVMCOTaEp, SVMCITaEp} from '../core'
import {SVMCOInputEp, SVMCDInputEp} from '../core'
/*
import { SVMCIInputEp,SVMCOTaEp, SVMCITaEp, SVMCOInputEp,SVMCDInputEp} from '../core'
import asyncValidate from './asyncValidate'
import {SVDate} from '../core'
*/

import {  Link } from "react-router-dom"
import {flyLoadsvmciData as loadFlyMciDataDB } from '../../redux/svractions/svflysearchActions'
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'

import { Icon } from 'antd';

import {SVMCIFORM} from '../../constants'
const React = require('react')



const {connect}  = require("react-redux")
const _ = require('lodash')




const svChange = (values, dispatch, props, valuesPrev)=>{

  console.log('sv form change')

  console.log(values)


}
const normalizeNumber = value=>{

  let outValue = value

  if(!value){
      return outValue
  }

  const onlyNums = value.replace(/[^\d]/g, '')

  outValue = onlyNums
  console.log(onlyNums)
  return outValue
  //return outValue
}


const portTypes=[{
    key:'CL_Number',
    value:'number'
  },{
    key:'CL_String',
    value:'string'
  
  },{
    key:'CL_Date',
    value:'date'   
   
  }]
  
  const svtypes= ['single', 'double', 'complex']
  
  //inputSchemaType

const holderTypes = [{
    name:'CL_Y',
    value:'Y'
  },{
    name:'CL_N',
    value:'N'
  
  }]
  const genderTypes = [{
    name:'CL_MALE',
    value:'MALE'
  },{
    name:'CL_FEMALE',
    value:'FEMALE'
  
  }] 
  const deviceTypes = [{
    name:'CL_MOBILE',
    value:'MOBILE'
  },{
    name:'CL_PAGER',
    value:'PAGER'
  
  }]
  
const documentTypes = [{
    name:'CL_PASSPORT',
    value:'PASSPORT'
  },{
    name:'CL_IDENTITY_CARD',
    value:'IDENTITY_CARD'
  
  }]
  const inputSchemaTypes = [{
    name:'JSON',
    value:'JSON'
  },{
    name:'XML',
    value:'XML'
  },{
    name:'SVG',
    value:'SVG'
  }]
  const locationTypes = [{
      name:'START',
      value:'START'
  },{
      name:'CARRIER',
      value:'CARRIER'
  },{
      name:'END',
      value:'END'
  }]
  const transformToBA =(values)=>{
    let data ={
        id: values.id ||'addLeft_STEP',
        gene: values.gene ||'addLeft_STEP',
        lastName:'add_step',
        portType:'number',
        portInput :10,
        location:'START'
       
    
    }
  
   let members = values.members
  let  o ={
    id:data.id,
    inputPorts:['portA', 'portB'],
    gene:data.gene,
    location:data.location,
    input:{
        bindingType:'json',
        portA:{
            input:data.portInput,
            type:data.portType
  
        },
        portB:{
            input:20,
            type:'number'
  
        }
    }
  }  
  let   portResolved = _.findWhere(members, {portName:'portA'})
  if(portResolved){
    o.input['portA']= {
      input:portResolved.portInput,
      type: portResolved.portType
    }
    
  
  }
  
  portResolved = _.findWhere(members, {portName:'portB'})
  if(portResolved){
    o.input['portB']= {
      input:portResolved.portInput,
      type:portResolved.portType
    }
  
  }
  

  return o
  
  }
  let data ={
      id:'addLeft_STEP',
      gene:'addLeft_STEP',
      lastName:'add_step',
      portType:'number',
      portInput :10,
      location:'START'
  }

/*
const renderMembersPort=(o)=>{
  const {countryTypes} = this.props
  const {fields, meta:{error, submitFailed, pristine, submitting}} =o
  
   console.log('renderMembers should generate empty object')
  // let fields = members
     console.log(fields)
   return( <div className="c-container-sbar">
    
       

       {
            fields.map((member, index) => {
                console.log(o)
                
               return(
                <div className="c-container-sbar"  key={index}>
              
               

                
                         
                                           
                 <div className="c-box-mcitybar" style={{display:"none"}}>
                 <span className="c-span" >
                                              
                                                    
                                                    <Field
                                                    normalize={normalizeNumber} 
                                                        id={`${member}.tid`}
                                                        name={`${member}.tid`}
                                                        name="tid"
                                                        type="text"
                                                        placeholder=""
                                                        component="input"
                                                        className="form-control"
                                                    />
                
                                                

                </span>         
                       
                </div>
                <div className="c-box-mcitybar">
                <span className="c-span form-inline">
                <div className="form-group">
                            <label className="mcity-label" htmlFor={`${member}.my_orgqueryText`}> From</label>
                            <SVMCOTaEp member={member} index={index} placeholder="JFK" /> 
                            
                                                   
                                                
                        </div>
                                            </span>
                </div>
                <div className="c-box-mcitybar">
                        <span className="c-span form-inline"> 
                          <div className="form-group">
                              <label className="mcity-label" htmlFor="`${member}.issuanceCountry`" > Issuance Country</label>
                        
                              <SVMCOInputEp countryTwoTypes={countryTypes} member={member} index={index} placeholder="ES" /> 
                            
                          </div> 
                        </span>
                </div>
                   
                <div className="c-box-mcitybar">
                        <span className="c-span form-inline">   
                        <div className="form-group">
                            <label className="mcity-label" htmlFor={`${member}.my_dstqueryText`}> To</label>
                            <SVMCITaEp member={member} index={index} placeholder="ORD" /> 
                            
                                                   
                        </div>
                                    
                                            </span>
                </div>
                <div className="c-box-mcitybar">
                                          
                <span className="c-span form-inline"> 
                <div className="form-group">
                    <label className="mcity-label" htmlFor={`${member}.STARTDATE`}> Travel Date</label>
                    <SVMCIInputEp member={member} index={index} placeholder="2035-04-13" /> 
                   

                   
                 
                                    </div>
                                            </span>

                 </div>    
                 <div className="c-box-mcitybar">
                 <span className="c-span">
                    <button
                    type="button"
                    className="btn btn-danger"      
                    onClick={() => fields.remove(index)}
                    >Remove City</button>
                    <h4 style={{display:"none"}}>Mcity #{index + 1}</h4>
                </span>
                </div>                  
                                            
                                           
                                           
                                    
                                           
                                        
                                        
                                    
                       

               
         </div>
             )})

       }
      <div className="c-box-mcitybar">
         
         <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add City </button>
         { submitFailed && error && <span>{error} </span>}
         <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
                Search Flight
              </button>  
      </div>
      

      </div> )
      
}
*/

  const getPortValue = (key)=>{
    let o = _.findWhere(portTypes, {key:key})
    return o.value
  }
const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )

  let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]


let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]


  let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            console.log(errors)
            return errors
        }
       
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
      
       console.log('FlyPaymentDEtailFormBusCom validate error *************')
        console.log(errors)
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
       
        return o
    }
class FlyMciFormBus extends React.Component{

  svCountryDstChange(escountryDstMCity, member){

    console.log('sv*****Sep2******country member')
    console.log(member)
    
    let is=null, ix = null,s=null,sp = null
    s= member
    is = s.indexOf('[') 
ix = s.indexOf(']') 
sp =s.slice(is+1,ix) 
 let dstIdx = `DST${sp}`
 console.log('sv*****Sep2******country dstIdx',dstIdx)


    let f = this.state.filters
    let eob =f['escountryDstMCity']
    console.log('sv*****Sep2******country old eob ',eob) 
    eob[dstIdx] =  escountryDstMCity
    console.log('sv*****Sep2******country new eob ',eob) 
    f['escountryDstMCity']  = eob

    // escountryOrgMCityObject
    //this.state.escountryDstMCity = escountryDstMCity
  }
  
  svCountryChange(escountryOrgMCity, member){

    console.log('sv*****Sep2******country member')
    console.log(member)
    
    let is=null, ix = null,s=null,sp = null
    s= member
    is = s.indexOf('[') 
ix = s.indexOf(']') 
sp =s.slice(is+1,ix) 
 let orgIdx = `ORG${sp}`
 console.log('sv*****Sep2******country orgIdx',orgIdx)


    let f = this.state.filters
    let eob =f['escountryOrgMCity']
    console.log('sv*****Sep2******country old eob ',eob) 
    eob[orgIdx] =  escountryOrgMCity
    console.log('sv*****Sep2******country new eob ',eob) 
    f['escountryOrgMCity']  = eob

    // escountryOrgMCityObject
    //this.state.escountryOrgMCity = escountryOrgMCity
  }
 renderMembersPort=(o)=>{
  const {countryTypes} = this.props
  const {svCountryChange,svCountryDstChange} = this
  const {fields, meta:{error, submitFailed, pristine, submitting}} =o
  /*
  let members = [
            {
                "tid": 1,
                "my_orgqueryText": "JFK",
                "my_dstqueryText": "LAX",
                "STARTDATE":"2024-12-03",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata"
               
            },
            {
                "tid": 2,
                "my_orgqueryText": "LAX",
                "my_dstqueryText": "SFO",
                "STARTDATE":"2024-12-07",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata"
               
            },
            {
                "tid": 3,
                "my_orgqueryText": "SFO",
                "my_dstqueryText": "JFK",
                "STARTDATE":"2024-12-17",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata"
               
            }
        ]
  console.log(o)
  */
   console.log('renderMembers should generate empty object')
  // let fields = members
     console.log(fields)
   return( <div className="c-container-sbar">
    
       

       {
            fields.map((member, index) => {
                console.log(o)
                
               return(
                <div className="c-container-sbar" style={{paddingTop:"13px"}}  key={index}>
              
               

                
                         
                                           
                 <div className="c-box-mcountrybar" style={{display:"none"}}>
                 <span className="c-span" >
                                              
                                                    
                                                    <Field
                                                    normalize={normalizeNumber} 
                                                        id={`${member}.tid`}
                                                        name={`${member}.tid`}
                                                        name="tid"
                                                        type="text"
                                                        placeholder=""
                                                        component="input"
                                                        className="form-control"
                                                    />
                
                                                

                </span>         
                       
                </div>
                <div className="c-box-mcountrybar">
                <span className="c-span form-inline">
                <div className="form-group">
                            <label className="mcity-label" htmlFor={`${member}.my_orgqueryText`}> From</label>
                            <SVMCOTaEp escountryOrgMCityOb={this.state.filters.escountryOrgMCity} countryTwoTypes={countryTypes} member={member} index={index} placeholder="JFK" /> 
                            {/*  
                                   <Field
                                                
                                                        id={`${member}.my_orgqueryText`}
                                                        name={`${member}.my_orgqueryText`}
                                                        
                                                        type="text"
                                                        placeholder="JFK"
                                                        component="input"
                                                        className="form-control"
                                                    />
                            */}
                                                   
                                                
                        </div>
                                            </span>
                </div>
                <div className="c-box-mcountrybar" style={{paddingLeft:"1px"}}>
                        <span className="c-span form-inline"> 
                          <div className="form-group">
                              <label className="mcity-label" htmlFor="`${member}.issuanceCountry`" >Country(From)</label>
                        
                              <SVMCOInputEp svCountryChange={svCountryChange} countryTwoTypes={countryTypes} member={member} index={index} placeholder="ES" /> 
                            
                          </div> 
                        </span>
                </div>
                {/* 
                
                */}
                
                  
                <div className="c-box-mcountrybar">
                        <span className="c-span form-inline">   
                        <div className="form-group">
                            <label className="mcity-label" htmlFor={`${member}.my_dstqueryText`}> To</label>
                            <SVMCITaEp escountryDstMCityOb={this.state.filters.escountryDstMCity} countryTwoTypes={countryTypes} member={member} index={index} placeholder="ORD" /> 
                            {/*  
                             <Field
                                                
                                                   
                                                    id={`${member}.my_dstqueryText`}
                                                    name={`${member}.my_dstqueryText`}
                                                        placeholder="SV"
                                                        component="input"
                                                        className="form-control"
                                                    />
                            */}
                                                   
                        </div>
                                    
                                            </span>
                </div>
                <div className="c-box-mcountrybar" style={{paddingLeft:"1px"}} >
                        <span className="c-span form-inline"> 
                          <div className="form-group">
                              <label className="mcity-label" htmlFor="`${member}.issuanceCountry`" >Country(To)</label>
                        
                              <SVMCDInputEp svCountryDstChange={svCountryDstChange} countryTwoTypes={countryTypes} member={member} index={index} placeholder="ES" /> 
                            
                          </div> 
                        </span>
                </div>
                {/* dest select dd end */}
                <div className="c-box-mcountrybar">
                                          
                <span className="c-span form-inline"> 
                <div className="form-group">
                    <label className="mcity-label" htmlFor={`${member}.STARTDATE`}> Travel Date</label>
                    <SVMCIInputEp member={member} index={index} placeholder="2035-04-13" /> 
                   
{/*   
     <Field
                                                    
                                                    id={`${member}.STARTDATE`}
                                                    name={`${member}.STARTDATE`}
                                                            type="text"
                                                            placeholder="2024-12-22"
                                                            component="input"
                                                            className="form-control"
                                                        />
*/}
                   
                    {/* 
                    <SVDate svfieldType="CL_String" portId={`${member}.STARTDATE`} > </SVDate>)
       
                                                   
                                                     */}
                                    </div>
                                            </span>

                 </div>    
                 {/*  
                 <p className="right-sd-content"> <span   onClick={() => fields.remove(index)}><Icon  style={{ color: '#e30b29' }} type="delete" theme="filled" /></span></p>
                 
                 <div className="c-box-mcountrybar">
                 <span className="c-span">
                    <button
                    type="button"
                    className="btn btn-danger"      
                    onClick={() => fields.remove(index)}
                    >Remove City</button>
                    <h4 style={{display:"none"}}>Mcity #{index + 1}</h4>
                </span>
                </div>     
                 */}
                 <div style={{marginTop:"22px"}} >
                    <span  onClick={() => fields.remove(index)} className="c-span">
                    <Icon  style={{ color: '#e30b29' ,fontSize:"30px"}} type="delete" theme="filled" />
                        <h4 style={{display:"none"}}>Mcity #{index + 1}</h4>
                    </span>
                </div>                  
                                            
                                           
                                           
                                    
                                           
                                        
                                        
                                    
                       

               
         </div>
             )})

       }
       <div className="c-container-actionbar" style={{paddingTop:"20px"}}>
          <div className="c-box-actionbar-start">
            
            <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add City </button>
           
              
          </div>
          <div className="c-box-actionbar">
            
           
            { submitFailed && error && <span>{error} </span>}
            <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
                    Search Flight
                  </button>  
          </div>
       </div>
     
      

      </div> )
      
}

  render(){
    console.log('sv... FlyMciFormBus')
    const { handleSubmit, pristine, error,reset, submitting } = this.props
    const { load, initialValues } = this.props
    //we always get iniitalValues that is default the form uses as kv pair 
    //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
   //we are copying all members from initialValues and senfint to props
   /* const {initialValues} = this.props
   

    */
    console.log("*****SVMCIFORM SEP4***** gets initialValues aka formdata  ")
    console.log(initialValues)
  
 //  let svorg = selector(state, 'members[2].mcicountryOrg')
   // console.log("SV88aug30** svorg found****8",svorg)
    console.log(this.props)
    return (
        <div style={{marginTop: "20px"}}>
         
            <form  class="form-inline" onSubmit={handleSubmit}>
            
            <div className="mcity-row">
                        

                        <FieldArray name="members" component={this.renderMembersPort} />
                                                      
                                              
                                           
                                           
                                    
                                           
                                        
                                        
                                    
                       

   
    
                   
                   
                   
                                           <div>
               
              
                     
               
                </div>
    
                   
                    </div>
                
                    
            </form>
        
        </div>
     )
}
    constructor(props){
        super(props)
        let me = this
        this.state = {
            filters: {
                  escountryOrgMCity : {
                    ORG0:'US', 
                  ORG1 :'US', 
                  ORG2:'US'
                  },
                  
                  escountryDstMCity : {
                        DST0:'US', 
                      DST1 :'US', 
                      DST2:'US'
                  },
            }
        }
        this.svCountryChange = this.svCountryChange.bind(me)
        this.svCountryDstChange = this.svCountryDstChange.bind(me)
        this.renderMembersPort = this.renderMembersPort.bind(me)
        this.loadGene = this.loadGene.bind(me)
        this.ddChange = this.ddChange.bind(me) 
       
        /*
        this.getAppDetails = this.getAppDetails.bind(this)
        */
       
    }
    componentWillMount()	{
        console.log('sv--Nov17 call DocumentData  should needs my_data_svmci action load to gtethe formvalues mciForm')
           const {   my_data_svmci} = this.props
         console.log('sv-- FlyMciFormBusCom   ')
      
       
        console.log(my_data_svmci)
         console.log('sv--AmbStepFormEp dcustProfile from  SVWizrd end')
         if( my_data_svmci && (my_data_svmci.members.length > 0)){
            console.log('sv--AmbStepFormEp dcustProfile from  SVWizrd calls load ')
            console.log(my_data_svmci)
            this.props.load(my_data_svmci)
         }else{
            this.props.load()
         }
        
        
    console.log('sbv--AmbStepFormEp sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
    
    
	}
    
    loadGene(e){
        console.log(e)
    }
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
   
}

const mciForm = reduxForm({

    form:SVMCIFORM,
    validate:validate,
   // asyncValidate: asyncValidate,
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(FlyMciFormBus)

const selector = formValueSelector(SVMCIFORM)


let FlyMciFormBusCom =connect((state=>{
    //we are not using key nmae intiailValues rathre returning flat content ky/valu as fpdData
    //reducForm provideis built in load - we have tp provide our action here  then our form component can call load from props
    //we cannot mofifiy initial Valy=ues or statehere only in reducers
//we have action loadAddressData from reviewaction that modiefied fpdData in TaskReducer. the address data is stored in this form. we will add card data also in fpdData
    let plucked = state.movies
    console.log('sv***FlyPaymentDocuments taskreducers')
    console.log(plucked)
    let my_data_svmci = state.svflysearch.my_data_svmci
       let o = {initialValues:plucked.mciData , "my_data_svmci":my_data_svmci}
    selector(state, 'id')
    console.log('sv NOV17 Payment Address info*********PAyment Address OCT5')
    console.log(o)
     
    //return plucked.fpdData
    return o
}),{
    //load:loadPdMyReservatiionsAddressAction,
    load:loadFlyMciDataDB,
    
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(mciForm)





export default FlyMciFormBusCom